import { render, staticRenderFns } from "./eventcomment.vue?vue&type=template&id=a848eeda"
import script from "./eventcomment.vue?vue&type=script&lang=js"
export * from "./eventcomment.vue?vue&type=script&lang=js"
import style0 from "./eventcomment.vue?vue&type=style&index=0&id=a848eeda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports